import React, { useState, useRef, useEffect } from "react";
import { Dropdown, DropdownButton, InputGroup, FormControl } from "react-bootstrap";
import { DateRange } from "react-date-range";
import { addDays, subMonths, addMonths, set } from "date-fns";
import calendarIcon from '../../../Images/calendarIcon.png';
import moment from "moment/moment";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./TransactionFilter.css";
import Buttons from "../../Buttons/Buttons";

const TransactionFilter = ({ setSearch, setStartUtcTime, setEndUtcTime }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selection, setSelection] = useState("Date Filter");
  const [expanded, setExpanded] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), -30),
      key: "selection",
    },
  ]);

  const ref = useRef(null);
  const calendarRef = useRef(null);

  const handleSelect = (eventKey) => {
    setSelection(eventKey);
    
    const today = new Date();
    let startDate, endDate = today.toISOString();
  
    switch (eventKey) {
      case "All":
        setStartUtcTime("");
        setEndUtcTime("");
        break;
  
      case "Today":
        startDate = addDays(today, -1);
        break;
  
      case "Past Week":
        startDate = addDays(today, -7);
        break;
  
      case "Past Month":
        startDate = addDays(today, -30);
        break;
  
      case "Custom":
        setShowCalendar(true);
        setExpanded(true);
        return;
  
      default:
        setShowCalendar(false);
        break;
    }
  
    if (startDate instanceof Date && !isNaN(startDate)) {
      setStartUtcTime(startDate.toISOString());
      setEndUtcTime(endDate);
    } else if (startDate) {
      console.error("Invalid date returned from addDays function");
    }
  };
  

  const handleSearch = () => {
    setSearch(searchQuery);
  }

  const handleCalendarSelect = (item) => { 
    setDateRange([item.selection]);
    moment().format();
    // save to utc format
    setStartUtcTime(item.selection.startDate.toISOString());
    setEndUtcTime(item.selection.endDate.toISOString());
  }
  const handleToggle = (isOpen, event) => {
    setExpanded(isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setExpanded(false);
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="filters" ref={ref}>
      <div className={`dropdown-filter-wrapper ${showCalendar ? "show-calendar" : ""}`}>
        <DropdownButton
          show={expanded || showCalendar}
          className="date-dropdown-wrapper"
          title={
            <>
              <div className="date-dropdown-div">
                <img className="calendar-icon" src={calendarIcon} alt="calendar" />
                <div>{selection}</div>
                <span className={`arrow ${expanded ? "up" : "down"}`}></span>
              </div>  
            </>
          }
          onToggle={handleToggle}
          onSelect={handleSelect}
        >
          <Dropdown.Item eventKey="All">All</Dropdown.Item>
          <Dropdown.Item eventKey="Today">Today</Dropdown.Item>
          <Dropdown.Item eventKey="Past Week">Past Week</Dropdown.Item>
          <Dropdown.Item eventKey="Past Month">Past Month</Dropdown.Item>
          <Dropdown.Item eventKey="Custom">Custom Date Range</Dropdown.Item>
        </DropdownButton>
        { showCalendar && (
          <DateRange
            editableDateInputs={true}
            onChange={handleCalendarSelect}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            className="calendar"
            months={2}
            direction="horizontal"
            calendarFocus="backwards"
            rangeColors={["#4BA1C6"]}
            ref={calendarRef}
          />
        )}
      </div>
      
      <InputGroup className="filter-search">
        <FormControl
          placeholder="Search by Transaction ID or Language Name"
          aria-label="Search"
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <Buttons handleSubmit={handleSearch} text="Search" />
      </InputGroup>
    </div>
  );
};

export default TransactionFilter;
